<!-- 예약번호 출입증 출력 페이지?? -->
<template>
<div id="payment_groom">
    <div class="pay_process">
    <div class="pay_process_wrap hidden-scroll">
        <!-- 왼쪽 메뉴-->
        <div class="process_content_left process_reservation">
            <ul>
                <li v-for="(item, index) in left_menu_list" :key="'left_menu'+index" :class="item['active_class']">
                    <div>
                        <img :src="item.img_src"><span>{{item.menu_name}}</span>
                    </div>
                </li>
                <div class="line"></div>
            </ul>
        </div><!-- 왼쪽 메뉴-->
        <!-- 오른쪽화면 -->
        <div class="process_content_right">
            <div class="pay_content_wrap">

                <!-- 카드/현금결제 -->
                <div class="pay_content_04 pay_content" v-if="step==2">
                    <div class="paytit">
                            <div class="paytit-text">결제방법</div>
                        </div>
                    <ul>
                        <template v-if="pay_type === 3 || pay_type === 1">
                            <li @click="set_pay_check(1)" class="pay-content-on" >
                                <div>카드결제</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_pay_check(0)">
                                <div>현금결제</div>
                                <div class="check"></div>
                            </li>
                        </template>
                        <template v-if="pay_type === 0">
                            <li @click="set_pay_check(1)">
                                <div>카드결제</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_pay_check(0)" class="pay-content-on">
                                <div>현금결제</div>
                                <div class="check"></div>
                            </li>
                        </template>
                    </ul>
                    <div class="card_select_box_wrap" v-if="pay_type === 3 || pay_type === 1">
                        <ul>
                            <li v-for="(item, index) in card_installment_list" @click="set_card_installment(item['month'], index)" :class="item['active_class']" :key="'card_installment_list'+index">
                                {{item.code_name}}
                            </li>
                        </ul>
                    </div>
                    <div class="money_select_box_wrap" v-if="pay_type === 0">
                        <!-- <ul>
                            <li>선택안함</li>
                            <li class="select_on">현금영수증</li>
                        </ul>
                        <select id="receipt_value" v-model="cash_receipt">
                            <option value="0" selected>-- 현금영수증 구분 --</option>
                            <option value="1" >개인(소득공제)</option>
                            <option value="2">법인(지출증빙)</option>
                        </select> -->
                    </div>
                </div><!-- 카드/현금결제 -->

                <!-- 마일리지 -->
                <div class="pay_content_05 pay_content" v-if="step==3 && mileage_use_yn == 1">
                    <div class="paytit">
                        <div class="paytit-text">마일리지</div>
                    </div>
                    <ul>
                        <template v-if="mileage_chk === false">
                            <li @click="set_mileage(false)" class="pay-content-on" >
                                <div>마일리지미사용</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_mileage(true)">
                                <div>마일리지사용</div>
                                <div class="check"></div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_mileage(false)" >
                                <div>마일리지미사용</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_mileage(true)" class="pay-content-on">
                                <div>마일리지사용</div>
                                <div class="check"></div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="mileage_chk === true">
                        <div class="mg_box_wrap">
                            <div>
                                <span>적립금액 :</span>
                                <mileage @milage="milage_payment" />
                            </div>

                            <div>
                                <span>적용금액 :</span>
                                <span>{{use_mileage}}</span>
                            </div>
                            <ul>
                                <li @click="set_mileage_button(use_min_unit)">+ {{use_min_unit}}</li>
                                <li @click="set_mileage_button(use_min_unit*2)">+ {{use_min_unit*2}}</li>
                                <li @click="set_mileage_button(use_min_unit*10)">+ {{use_min_unit*10}}</li>
                                <li @click="set_mileage_button('all')">전체적용</li>
                                <li @click="set_mileage_button('cancel')">전체취소</li>
                            </ul>

                            <p>※ 최소사용단위 : {{use_min_unit}}원    ※ 최소사용금액 : {{use_min_amount}}원</p>
                        </div>
                    </template>
                </div><!-- 마일리지 -->

                <!-- 할인쿠폰 -->
                <div class="pay_content_06 pay_content" v-if="step==4 && sale_use_yn == 1">
                    <div class="paytit">
                        <div class="paytit-text">할인쿠폰</div>
                    </div>
                    <ul>
                        <template v-if="discount_coupon === true">
                            <li @click="set_discount_coupon(false)" >
                                <div>할인쿠폰미사용</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_discount_coupon(true)" class="pay-content-on">
                                <div>할인쿠폰사용</div>
                                <div class="check"></div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_discount_coupon(false)" class="pay-content-on">
                                <div>할인쿠폰미사용</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_discount_coupon(true)" >
                                <div>할인쿠폰사용</div>
                                <div class="check"></div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="discount_coupon === true">
                        <div class="cp_box_wrap">
                            <div class="cp_box">
                                <span>쿠폰코드 :</span>
                                <span>{{discount_coupon_code | coupon_filter}}</span>
                            </div>
                            <button @click="coupon_check()">적용</button>
                        </div>

                        <div class="cp_num_pad">
                            <div class="pad_btn">
                                <span @click="coupoun_input('1')">1</span>
                                <span @click="coupoun_input('2')">2</span>
                                <span @click="coupoun_input('3')">3</span>
                                <span @click="coupoun_input('4')">4</span>
                                <span @click="coupoun_input('5')">5</span>
                                <span @click="coupoun_input('6')">6</span>
                            </div>
                            <div class="pad_btn">
                                <span @click="coupoun_input('7')">7</span>
                                <span @click="coupoun_input('8')">8</span>
                                <span @click="coupoun_input('9')">9</span>
                                <span @click="coupoun_input('0')">0</span>
                                <span @click="coupoun_input('del')"><img src='../../assets/image/delete_gy.png'></span>
                            </div>

                        </div>
                    </template>
                </div><!-- 할인쿠폰 -->

                <!-- 영수증 출력 -->
                <div class="pay_content_07 pay_content" v-if="step==5">
                    <div class="paytit">
                        <div class="paytit-text">영수증 출력</div>
                    </div>
                    <ul>
                        <template v-if="receipt_chk === 0">
                            <li @click="set_receipt_chk(0)" class="pay-content-on">
                                <div>영수증 미출력</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_receipt_chk(1)" >
                                <div>영수증 출력</div>
                                <div class="check"></div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_receipt_chk(0)">
                                <div>영수증 미출력</div>
                                <div class="check"></div>
                            </li>
                            <li @click="set_receipt_chk(1)" class="pay-content-on">
                                <div>영수증 출력</div>
                                <div class="check"></div>
                            </li>
                        </template>
                    </ul>
                </div><!-- 영수증 출력 -->

                <!-- 결제/카드  -->
                <div class="pay_content_08 pay_content" v-if="step==6">
                    <div class="card_payment_wrap" v-if="pay_type == 1">
                        <div class="payment_head">
                            <ul>
                                <li>
                                    <span class="pay_hd">결제금액</span>
                                    <span class="pay_ft">{{last_price_card}} 원</span>
                                </li>
                            </ul>
                        </div>

                        <div class="payment_body">
                            <p>결제하실 카드를 화면의 그림과 같이 투입해주세요.</p>
                            <img src="../../assets/image/card_gif.gif">
                            <span>결제가 완료될때까지 기다려주세요!</span>
                        </div>

                        <div class="payment_footer">
                            <button class="pay_cancle" @click="step_controll_back()">취소</button>
                        </div>
                    </div>

                    <div class="money_payment_wrap" v-if="pay_type == 0">
                        <div class="payment_head">
                            <ul>
                                <li>
                                    <span class="pay_hd">결제금액</span>
                                    <span class="pay_ft" v-if="pay_type == 1">{{last_price_card}} 원</span>
                                    <span class="pay_ft" v-if="pay_type == 0">{{last_price_cash}} 원</span>
                                </li>
                                <li>
                                    <span class="pay_hd">투입금액</span>
                                    <span class="pay_ft"> 0 원</span>
                                </li>
                            </ul>
                        </div>
                        <div class="payment_body">
                            <p>결제하실 현금을 화면의 그림과 같이 투입해주세요.</p>
                            <img src="../../assets/image/money_gif.gif">
                            <span>결제가 완료될때까지 기다려주세요!</span>
                        </div>

                        <div class="payment_footer">
                            <button class="pay_cancle" @click="step_controll_back()">취소</button>
                        </div>
                    </div>
                </div><!-- 결제/카드  -->

                <!-- 결제 완료 -->
                <div class="pay_content_09 pay_content" v-if="step==7">
                    <div class="finish_payment_wrap">
                        <div class="finish_head">
                            <ul>
                                <li>
                                    <span class="pay_hd">결제금액</span>
                                    <span class="pay_ft" v-if="pay_type == 1">{{last_price_card}} 원</span>
                                    <span class="pay_ft" v-if="pay_type == 0">{{last_price_cash}} 원</span>
                                </li>
                            </ul>
                        </div>

                        <div class="finish_body">
                            <p>결제가 완료되었습니다.</p>
                            <img src="../../assets/image/barcode_img.jpg">
                            <p>입력하신 휴대폰 번호로 <br><span>결제 정보</span>가 담긴 문자가 전송됩니다.</p>
                        </div>

                        <div class="finish_footer pay_content_btn">
                            <div class="ok_btn" @click="step_finish(-1)">확인</div>
                        </div>
                    </div>
                </div><!-- 결제 완료 -->
            </div>
            <div class="pay_info">
                <div class="pay_info_wrap" v-if="step <= 6">
                    <div class="pay_wrap">
                        <div class="line_top"></div>
                        <ul>
                            <li>
                                <span class="pay_hd">상품종류</span>
                                <span class="pay_ft">{{ goods_group_name }}({{type_name}})</span>
                            </li>
                            <li>
                                <span class="pay_hd">이용시간</span>
                                <span class="pay_ft">{{goods_time}}</span>
                            </li>
                            <li>
                                <span class="pay_hd">상품구분</span>
                                <span class="pay_ft">{{product_division}}</span>
                            </li>
                            <li>
                                <span class="pay_hd">결제방법</span>
                                <span class="pay_ft">{{pay_type_str}}</span>
                            </li>
                            <li>
                                <span class="pay_hd">마일리지</span>
                                <span class="pay_ft price">{{use_mileage}}원</span>
                            </li>
                            <li>
                                <span class="pay_hd">할인금액</span>
                                <span class="pay_ft price" v-if="pay_type == 0">{{discounted_price_cash}}원</span>
                                <span class="pay_ft price" v-if="pay_type == 1">{{discounted_price_card}}원</span>
                            </li>
                            <li>
                                <span class="pay_hd">결제금액</span>
                                <span class="pay_ft price" v-if="pay_type == 0">{{last_price_cash}}원</span>
                                <span class="pay_ft price" v-if="pay_type == 1">{{last_price_card}}원</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pay_content_btn" v-if="step == 2">
                        <div class="prev_btn" @click="beforeGoPage()" v-if="step!=7 && step!=8 && step!=15">
                            <img src="../../assets/image/arrow04.png" alt="">이전
                        </div>
                        <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                            다음<img src="../../assets/image/arrow04.png" alt="">
                        </div>
                    </div>
                    <div class="pay_content_btn" v-if="step==3 && mileage_use_yn == 1">
                            <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                                <img src="../../assets/image/arrow04.png" alt="">이전
                            </div>
                            <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                                다음<img src="../../assets/image/arrow04.png" alt="">
                            </div>
                    </div>
                    <div class="pay_content_btn" v-if="step==4 && sale_use_yn == 1">
                            <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                                <img src="../../assets/image/arrow04.png" alt="">이전
                            </div>
                            <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                                다음<img src="../../assets/image/arrow04.png" alt="">
                            </div>
                    </div>
                    <div class="pay_content_btn" v-if="step == 5">
                        <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                            <img src="../../assets/image/arrow04.png" alt="">이전
                        </div>
                        <div class="next_btn" @click="do_pay_check()" v-if="step!=7 && step!=8 && step!=15">결제하기</div>
                    </div>
                </div>
            </div>
        </div><!-- 오른쪽화면 -->
    </div>
    </div>
</div>
</template>

<script>
import vue from 'vue';
import * as config from '../../javascript/config';
import * as appVue from '../../App.vue'

// 결제모듈
import external from '@/assets/js/external.js';

export default {
    data: function () {
        return {
            step: 2,
            left_menu_list: [],
            card_installment_list :[
                {"month" : 0, 'code_name' : '일시불', active_class:"select_on"},
                {"month" : 2, 'code_name' : '2개월', active_class:""},
                {"month" : 3, 'code_name' : '3개월', active_class:""},
                {"month" : 4, 'code_name' : '4개월', active_class:""},
                {"month" : 5, 'code_name' : '5개월', active_class:""},
                {"month" : 6, 'code_name' : '6개월', active_class:""},
                {"month" : 7, 'code_name' : '7개월', active_class:""},
                {"month" : 8, 'code_name' : '8개월', active_class:""},
                {"month" : 9, 'code_name' : '9개월', active_class:""},
                {"month" : 10, 'code_name' : '10개월', active_class:""},
                {"month" : 11, 'code_name' : '11개월', active_class:""},
                {"month" : 12, 'code_name' : '12개월', active_class:""}
            ],

            now_date: '',
            end_date: '',
            select_groom_name: '',
            select_groom_id: '',
            select_groom_type_id: '',
            // 상품 목록 관련
            goods_group_name: "",
            type_name: "",
            // 상품 시간 목록 관련
            goods_time: '',
            cash_amount: '',
            card_amount: '',
            use_start_datetime: null,
            product_division: '예약',

            ////////

            //결제방법
            cash: true,
            pay_type: 1,
            card_installment: 0,
            pay_type_str: '',
            cash_receipt: '0', // 0 == 선택안함 1 == 개인(소득공제) 2 == 법인(지출증빙)
            //마일리지
            mileage_use_yn: '', //해당 매장에서 마일리지 사용여부
            mileage_chk: false,
            mileage_id: null,
            my_save_mileage: 0,
            // milage_all: false,
            use_mileage: 0,

            //할인쿠폰
            sale_use_yn: '', // 해당 매장에서 할인쿠폰 사용여부
            discount_coupon: false,
            discount_coupon_code: '',
            sale_id: 0,
            sale_rate: 0,
            discounted_price_cash: '0',
            discounted_price_card: '0',
            discount_flag: false,
            //영수증 출력 여부
            receipt: 3,

            // 내 좌석 상품 , 쿠폰

            last_price_cash: '',
            last_price_card: '',
            // 영수증 출력
            receipt_chk : 0,

            // 마일리지 사용 최소 단위
            use_min_unit: 0,
            // 마일리지 사용 최소 금액
            use_min_amount: 0,

            // 그룹룸 예약 정보
            reservation_info: {}
        }
    },
    filters:{
        coupon_filter(value){
            var num = new Number(value);
            num = num.toFixed(0).replace(/\B(?=(\d{4})+(?!\d))/g, "-");
            return `${num}`
        }
    },
    methods: {
        step_finish() {
            var router = this.$router;
            router.push('/');
        },
        step_controll(val) {
            this.step += val;

            if (this.step == 3 && this.pay_type == 1 && this.card_installment == 13) {

                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `할부개월을 선택해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }
            if(this.step == 3 && this.card_installment > 0 && this.last_price_card.replace(/,/g,"") < 50000){
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `50,000원 미만은 할부를 할 수 없습니다.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }
            if (this.pay_type == 3 && this.step == 3) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `결제방법을 선택해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }

            if (this.step == 3 && this.pay_type == 0) {
                this.pay_type_str = '현금결제';
                this.last_price_cash = this.cash_amount;
                this.last_price_card = this.card_amount;
            } else if (this.step == 3 && this.pay_type == 1) {
                this.pay_type_str = '카드결제';
                this.last_price_cash = this.cash_amount;
                this.last_price_card = this.card_amount;
            }

            if (this.mileage_use_yn == 1 && this.step == 4) {
                if(this.mileage_chk){
                    if(this.use_mileage < this.use_min_amount){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `마일리지가 최소 금액보다 부족합니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.step -= 1;
                        return;
                    }
                }
            }

            if (this.step == 4 && this.use_mileage > 0) {
                var cash = 0;
                var card = 0;
                cash = this.cash_amount.replace(/,/g,"");
                card = this.card_amount.replace(/,/g,"");

                let amount;
                if(this.pay_type === 0){
                    amount = cash;
                }else if(this.pay_type === 1){
                    amount = card;
                }

                if(amount < this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `마일리지가 결제 금액보다 큽니다.`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.step -= 1;
                    this.use_mileage = 0;
                    return;
                }else{
                    cash = cash - this.use_mileage;
                    card = card - this.use_mileage;

                    this.last_price_cash = cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            } else if (this.step == 4 && this.use_mileage == 0 && !this.mileage_chk) {
                this.last_price_cash = this.cash_amount;
                this.last_price_card = this.card_amount;
            } else if (this.step == 4 && this.use_mileage == 0 && this.mileage_chk) {
                this.last_price_cash = this.cash_amount;
                this.last_price_card = this.card_amount;
            }

            if (this.step == 4 && this.discount_flag) {
                var price_cash = this.last_price_cash.replace(/,/g,"");
                var price_card = this.last_price_card.replace(/,/g,"");
                //할인된 금액
                var discounted_price_cash = Math.round(price_cash * (this.sale_rate / 100)); // 정수로 출력하기 위해 소수점 아래 반올림 처리
                var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                // 계산된 최종금액
                var new_price_cash = price_cash - discounted_price_cash;
                var new_price_card = price_card - discounted_price_card;
                //최종금액
                this.last_price_cash = new_price_cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //할인된 최종금액
                this.discounted_price_cash = discounted_price_cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            if (this.mileage_use_yn != 1 && this.step == 3) {
                this.step = 4;
            }
            if (this.sale_use_yn != 1 && this.step == 4) {
                this.step = 5;
            }

        },
        beforeGoPage(){
            this.$store.commit('set_groom_reservation_pay', false);
            this.$router.push('/');
        },
        step_controll_back() {
            this.step -= 1;
            if(this.step == 6){
                this.$store.commit('set_payment_Start', false);
                if(this.pay_type == 0){
                    this.input_cash = '0';
                    cashBoard.clear();
                }
            }
            if (this.step == -1) {
                var router = this.$router;
                var last_url = this.$store.getters['get_last_url'];
                if (last_url == undefined ||
                    last_url == null ||
                    last_url == '' ||
                    last_url == 'undefined' ||
                    last_url == 'null' ||
                    last_url.length == 0) {
                    router.push('/');
                } else {
                    router.push(last_url); // 이동 위치를 입력
                }
            }
            if (this.sale_use_yn != 1 && this.step == 4) {
                this.step = 3;
            }
            if (this.mileage_use_yn != 1 && this.step == 3) {
                this.step = 2;
            }
        },
        set_pay_check(index) {
            this.pay_type = index;
            this.last_price_cash = this.cash_amount;
            this.last_price_card = this.card_amount;
            if(index == 1){
                this.pay_type_str = '카드결제';
            }else{
                this.pay_type_str = '현금결제';
            }
        },

        set_card_installment(month, index) {
            for(var i = 0; i <this.card_installment_list.length; i++){
                this.card_installment_list[i].active_class = '';
            }
            this.card_installment_list[index].active_class = 'select_on';
            this.card_installment = month;
        },
        set_mileage(type) {
            if(type){
                this.mileage_chk = true;
            }else{
                this.use_mileage = 0;
                this.mileage_chk = false;
            }
        },
        set_mileage_button(value) {
            if(this.use_min_amount > this.my_save_mileage){
                let use_min_amount_text = this.use_min_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `${use_min_amount_text} 마일리지 이상부터 사용 가능합니다.`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage = 0;
                return false;
            }
            
            if(typeof value === 'number'){
                this.use_mileage += parseInt(value);
            }else {
                this.use_mileage =  this.my_save_mileage;
            }

            if (this.use_mileage > this.my_save_mileage) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `사용하시려는 마일리지가 보유하고계신 마일리지보다 큽니다`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage -= value;
                return;
            }

            let amount = this.pay_type === 0 ? this.last_price_cash : this.last_price_card;

            var remain_pay = parseInt(parseInt(amount.replace(/,/g,""))/this.use_min_unit)*this.use_min_unit;
            if(value === 'all'){
                this.use_mileage = this.my_save_mileage;
                if(this.use_mileage == 0 || this.use_mileage == '0'){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 없습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                }

                if(remain_pay > this.use_mileage){
                    remain_pay = parseInt(this.use_mileage/this.use_min_unit)*this.use_min_unit;
                    this.use_mileage = remain_pay;
                }


                if(this.use_min_amount > this.use_mileage || remain_pay > this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 충분하지않습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.use_mileage = 0;
                }
            }else if(value === 'cancel'){
                this.use_mileage = 0;
                this.last_price_card = this.card_amount;
                return false;
            }

            if(amount.replace(/,/g,"") < this.use_mileage){
                this.use_mileage = remain_pay;
            }

            var card = 0; 
            card = this.card_amount.replace(/,/g,"");
            card = card - Number(this.use_mileage) * 1;
            this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        },
        milage_payment(mileage_data) {
            this.my_save_mileage = mileage_data;
        },
        set_discount_coupon(type) {
            if(type){
                this.discount_coupon = true;
            }else{
                this.discount_coupon = false;
            }
        },
        coupon_check() {
            //할인쿠폰 적용 여부
            if (this.discount_coupon) {

                const type = config.REQ_COUPON_GET;
                const data = {
                    'sale_code': this.discount_coupon_code.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-")
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    var result;
                    result = response.result;
                    if (result && !this.discount_flag && response.data.message) {
                        this.sale_id = response.data.data[0].sale_id;
                        this.sale_rate = response.data.data[0].sale_rate;

                        var price_cash = this.last_price_cash.replace(/,/g,"");
                        var price_card = this.last_price_card.replace(/,/g,"");
                        //할인된 금액
                        var discounted_price_cash = Math.round(price_cash * (this.sale_rate / 100)); // 정수로 출력하기 위해 소수점 아래 반올림 처리
                        var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                        // 계산된 최종금액
                        var new_price_cash = price_cash - discounted_price_cash;
                        var new_price_card = price_card - discounted_price_card;
                        //최종금액
                        this.last_price_cash = new_price_cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //할인된 최종금액
                        this.discounted_price_cash = discounted_price_cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        this.step++;
                        this.discount_flag = true;
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 적용되었습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (!result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (result && this.discount_flag) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 이미 적용되어있습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },
        set_receipt_chk(index) {
            this.receipt_chk = index;
            this.receipt = index;
        },

        do_pay() {
            var self = this;

            // 상품종류 code 좌석/사물함/그룹룸
            var get_item_code = this.$store.getters['get_tab_code_list'];
            for (let i = 0; i < get_item_code.length; i++) {
                if (get_item_code[i].code_name == "그룹룸") {
                    get_item_code = get_item_code[i].code;
                    break;
                }
            }

            var left_time;

            var payment_kind_code;
            var payment_amount;
            var goods_amount;
            var sale_amount;
            var card_div;

            //현금 / 카드 사용여부 체크 그에따른 값 셋팅
            if (this.pay_type == 0) {
                payment_kind_code = 'CASH';
                payment_amount = this.last_price_cash;
                goods_amount = this.cash_amount;
                sale_amount = this.discounted_price_cash;
                card_div = 13;
                cashBoard.clear();
            } else if (this.pay_type == 1) {
                payment_kind_code = 'CARD';
                payment_amount = this.last_price_card;
                goods_amount = this.card_amount;
                sale_amount = this.discounted_price_card;
                card_div = this.card_installment // 1 = 일시불 2 = 2개월
            }
            goods_amount = goods_amount.replace(/,/g,"");
            payment_amount = payment_amount.replace(/,/g,"");
            sale_amount = sale_amount.replace(/,/g,"");
            // 마일리지 사용여부 체크
            var mileage = {};

            if (this.mileage_chk) {
                mileage = {
                    'total_amount': Number(this.my_save_mileage) - this.use_mileage, // '총_금액', => 총금액 - 마일리지 사용 금액
                    'change_amount': this.use_mileage // '변동_금액',  => 마일리지 사용 금액
                }
            }

            //할인쿠폰 사용여부 체크
            var sale = {};

            if (this.discount_coupon && this.discount_flag) {
                sale = {
                    'sale_id': this.sale_id
                }
            } else {
                this.sale_id = null;
            }
            //사용 종료시간 체크

            const type = config.REQ_PAYMENT_INSERT;
            const data = {
                'data': {
                    'mileage_yn': this.mileage_chk, //'마일리지_사용_여부', Y or N
                    'sale_yn': this.discount_coupon, // 할인쿠폰 사용여부
                    'purchase_type': 'RESERVATION', //'구매_타입', // seat || locker || groom
                    'dirUseCheck': false, //false 상품구매 true 즉시사용
                    'mobile_yn': false, // 모바일 여부

                    'payment': {
                        'sale_id': this.sale_id, //'할인권_ID'
                        'payment_kind_code': payment_kind_code, // 현금인지 카드인지
                        'payment_status_code': 'COMPLETE',
                        'goods_type_code': get_item_code, // TAB 에 달려있는 데이터를 넣어줘야함
                        'approval_number': null,
                        'payment_amount': payment_amount * 1,
                        'goods_amount': goods_amount * 1,
                        'sale_amount': sale_amount * 1,
                        'card_div': card_div,
                        'goods_name': this.goods_group_name + '_' + this.type_name + ''
                    },

                    // 마일리지_사용_여부가 'Y'일때
                    mileage: mileage,

                    // 할인쿠폰_적용_여부가 'Y'일때
                    'sale': sale,

                    'purchase': {
                        'groom_reservation_id': this.reservation_info.groom_reservation_id,
                        'groom_purchase_history_id': this.reservation_info.groom_purchase_history_id
                    }
                }
            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}

            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                if (response.result) {
                    this.$store.commit('set_groom_reservation_pay', false);
                    self.step_controll(1);
                }

            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        // 쿠폰입력
        coupoun_input(type_num){
            if(type_num == 'del'){
                if(this.discount_coupon_code.length != 0){
                    this.discount_coupon_code = this.discount_coupon_code.substr(0, this.discount_coupon_code.length-1);
                }
            }else{
                if(this.discount_coupon_code.length <= 11){
                    this.discount_coupon_code = this.discount_coupon_code + type_num;
                }else{
                    return false;
                }
            }
        },
        // 결제 모듈 기다린 후 돈 투입 or 카드 결제 시 반응
        responseByBillModule(){
            var self = this;
            self.$store.commit('set_payment_Start', true);
            var suc_function = function(command, result){
                if(command == 'success'){
                    self.do_pay();
                }else if(command == 'message'){
                    self.input_cash = result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }else if(command == 'complete'){
                    self.cash_wait_text = result;
                }else{
                    const alert_param = {
                        code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: result.message,
                        router: '',
                    };
                    self.$store.commit('set_popup_type', alert_param);
                }
                self.$store.commit('reset_logout_timer_true', {
                    value: ''
                });
            }

            var receipt_yn = this.receipt_chk;
            if(receipt_yn == 0){
                receipt_yn = 'n'
            }else{
                receipt_yn = 'y'
            }

            let card_money = this.card_amount.replace(/,/g,"")
            let cash_money = this.cash_amount.replace(/,/g,"")

            if(this.pay_type == 0){// 현금
                if(cash_money == this.use_mileage) {
                  self.do_pay();
                }else{
                  external.paymentByCash(this.last_price_cash, this.cash_receipt_flag , this.cash_receipt, suc_function);
                }
            }else{// 카드결제
                if(card_money == this.use_mileage) {
                  self.do_pay();
                }else{
                  external.paymentByCard(this.last_price_card, this.card_installment, suc_function);
                }
            }
        },  // 왼쪽 메뉴
        get_left_menu(){
            this.left_menu_list =  [];
            if(this.mileage_use_yn != 0){
                this.left_menu_list.push({active_class: "process_on", img_src:  require("../../assets/image/process04_on.png"), menu_name : "마일리지" , nomal_step : 4});
            }
            if(this.sale_use_yn != 0){
                this.left_menu_list.push({active_class: "process_on", img_src:  require("../../assets/image/process05_on.png"), menu_name : "할인쿠폰" , nomal_step : 5});
            }
            this.left_menu_list.push({active_class: "process_on", img_src:  require("../../assets/image/process06_on.png"), menu_name : "결제" , nomal_step : 6});
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process07_on.png"), menu_name : "완료" , nomal_step : 7});
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.reservation_info = this.$store.getters.get_reservation_info;

            // 그룹룸 상품 호출 req
            const type = config.REQ_RESERVATION_GOODS_GET;
            const data = {
                'reservation_id': this.reservation_info.groom_reservation_id
            };

            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                this.goods_group_name = response.data.goods_group_name;
                this.goods_time = response.data.use_start_datetime;
                this.type_name = response.data.type_name;
                this.card_amount = response.data.card_amount;
                this.cash_amount = response.data.cash_amount;
                this.last_price_card = response.data.card_amount;
                this.last_price_cash = response.data.cash_amount;
                this.pay_type_str = '카드결제'

            }).catch(function (error) {
                console.log('error=============>', error);
            });

            var yndata = this.$store.getters['getUseyn'];
            if(typeof yndata == "undefined"){
                this.sale_use_yn = 0;
                this.mileage_use_yn = 0;
            }else{
                this.sale_use_yn = yndata.sale_apply_yn;
                this.mileage_use_yn = yndata.use_yn;
                this.use_min_unit = yndata.use_min_unit;
                this.use_min_amount = yndata.use_min_amount;
            }

            this.get_left_menu();
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var currentTime = today.getHours() + "시 " + today.getMinutes() + "분 ";

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            this.now_date = today = yyyy + '/' + mm + '/' + dd + ' ' + currentTime;

        });

    },
    beforeDestroy(){
        if(this.pay_type == 0){
            cashBoard.clear();
        }
        this.$store.commit('set_payment_Start', false);
    },
    watch:{
        step(){
            for(var i = 0; i < this.left_menu_list.length; i++){
                this.left_menu_list[i].active_class = '';
                if(this.left_menu_list[i].nomal_step == (this.step+1)){
                    this.left_menu_list[i].img_src = require("../../assets/image/process0"+(this.left_menu_list[i].nomal_step+1)+"_on.png");
                    this.left_menu_list[i].active_class = 'process_on';
                    for (var n=0; n<i; n++) {
                        this.left_menu_list[n].active_class = 'process_finish';
                    }
                }else{
                    this.left_menu_list[i].img_src = require("../../assets/image/left_ico_0"+(this.left_menu_list[i].nomal_step+1)+".png");
                }
            }
            if(this.step == 6){
                // this.responseByBillModule();
                this.do_pay();
            }

        },
    }
}
</script>

<style>
</style><style>
.vdp-datepicker .vdp-datepicker__calendar {
    position: relative;
    /* // width: 355%; */
    height: 100%;

}

.good-body .info_area_2 {
    position: absolute;
    background: #fff;
    top: 10%;
    left: 40%;
    width: 632px;
    height: 650px;
    border: 3px solid #b9b9b9;
    border-radius: 2.5px;
    padding: 80px 60px 55px;
    font-size: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Payment_reservation.vue